<div class="sideMenuContainer">
    <div class="sideMenu">
        <ul class="menuItems">
            @for (c of mainPageComponents; track c) {
                <li
                    class="menuItem"
                    (click)="c.action()"
                    [ngClass]="{ 'menuItem-selected': c.isSelected() }"
                >
                    <div
                        class="side-menu-icon {{ c.icon }}"
                        aria-hidden="true"
                    ></div>
                    <div class="label" [hznTestId]="c.testId">{{ c.name }}</div>
                </li>
            }
        </ul>
    </div>
</div>
